module.exports = __webpack_public_path__ + "assets/img/12_142_big.67338e39.jpg";